import { v4 as uuidv4 } from 'uuid';

export default class MobileFiles {

  static available() {
    return window.cordova && window.cordova.file;
  }

  static getPathWithoutAppSpecificPart(filename) {
    if (filename.startsWith(window.cordova.file.dataDirectory)) {
      return filename.substring(window.cordova.file.dataDirectory.length);
    }
    return null;
  }

  static fixFilename(filename, path) {
    if (path && !filename.startsWith(window.cordova.file.dataDirectory)) {
      return window.cordova.file.dataDirectory + path;
    }
    return filename;
  }

  static loadBlobFromFilename(filename) {
    return new Promise(function(resolve, reject) {
      window.resolveLocalFileSystemURL(filename, (fileEntry) => {
        fileEntry.file((file) => {
          var reader = new FileReader();
          reader.onload = (event) => {
            const blob = new Blob([new Uint8Array(reader.result)], { type: 'image/jpeg' });
            resolve(blob);
          };
          reader.onerror = (e) => {
            reject(e);
          };
          reader.readAsArrayBuffer(file);
        },
        (error) => {
          reject(error); 
        });
      },
      (error) => {
        reject(error);
      });
    });
  }

  static persistFile(filename, doCopy = false) {
    // move to persistent storage (it is suggested to use dataDirectory so
    // that's just what we will do...
    return new Promise(function(resolve, reject) {
      window.resolveLocalFileSystemURL(filename,
        (fileEntry) => {
          window.resolveLocalFileSystemURL(window.cordova.file.dataDirectory,
            (dataDirectory) => {
              dataDirectory.getDirectory('uploads', { create: true }, 
                (uploadsDirectory) => {
                  let extension = filename.split('.').pop();
                  if (extension && extension.indexOf('/') >= 0) {
                    extension = null;
                  }
                  let newFilename = uuidv4() + (extension ? ('.' + extension) : '');
                  if (doCopy) {
                    fileEntry.copyTo(uploadsDirectory, newFilename,
                      (newEntry) => {
                        resolve(newEntry.toURL());
                      },
                      (error) => {
                        reject(error);
                      });
                  }
                  else {
                    fileEntry.moveTo(uploadsDirectory, newFilename,
                      (newEntry) => {
                        resolve(newEntry.toURL());
                      },
                      (error) => {
                        reject(error);
                      });
                  }
                },
                (error) => {
                  reject(error);
                });
            },
            (error) => {
              reject(error);
            });
        },
        (error) => {
          reject(error);
        });
    });
  }

  static persistBlob(blob, extension) {
    return new Promise(function(resolve, reject) {
      window.resolveLocalFileSystemURL(window.cordova.file.dataDirectory,
        (dataDirectory) => {
          dataDirectory.getDirectory('uploads', { create: true }, 
            (uploadsDirectory) => {
              let newFilename = uuidv4() + (extension ? ('.' + extension) : ''
);
              uploadsDirectory.getFile(newFilename, { create: true },
                (newFileEntry) => {
                  newFileEntry.createWriter((fileWriter) => {
                    fileWriter.onwriteend = (e) => {
                      resolve(newFileEntry.toURL());
                    };
                    fileWriter.onerror = (error) => {
                      reject(error);
                    };
                    fileWriter.write(blob);
                  });
                },
                (error) => {
                  reject(error);
                });
            },
            (error) => {
              reject(error);
            });
        },
        (error) => {
          reject(error);
        });
    });
  }

  static deleteFile(filename) {
    return new Promise(function(resolve, reject) {
      window.resolveLocalFileSystemURL(filename,
        (fileEntry) => {
          fileEntry.remove(
            (entry) => {
              resolve(true);
            },
            (error) => {
              reject(false);
            });
        },
        (error) => {
          reject(false);
        });
    });
    
  }

}



// WEBPACK FOOTER //
// ./src/helpers/MobileFiles.js